import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import Loadingcomponent from "../loader/loadingcomponent";
import ErrorMessage from "../messaging/errormessage";
import ExclusiveModal from "../../components/common/exclusive-modal";
import {GTMScreenView} from "../../../src/analytics/GoogleTagManager";
import {useSelector} from "react-redux";
import {CT_Events} from "../../../src/analytics/CTEvents";
const MoreAccountsList = ({ pmsitem }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [deeplinktext, setDeeplinktext] = useState("");
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const {CT_ScreenView} = CT_Events();
  const {
    data: { data } = {},
    isLoading,
    isFetching,
    error,
    isError,
    isLoadingError,
  } = useQuery(["", pmsitem.method, JSON.parse(pmsitem.sourceid), {}], {
    retry: false,
    retryOnMount: false,
  });

  useEffect(() =>{
    try{
      GTMScreenView("Accounts-list", msisdn, logintype);
    }catch{}
    try{
      CT_ScreenView()
    }catch{}   
  }, [])

  if (isLoading || isFetching) {
    return <Loadingcomponent message={"Loading"} />;
  }

  if (error || isError || isLoadingError) {
    return <ErrorMessage message={"Invalid"} />;
  }
  const list = data?.response?.dynamictypes[0]?.cards || [];

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const menuClick = (metalist) => {
    if (metalist?.length > 0) {
      { console.log(metalist, "_url_url_url") }
      for (var i = 0; i < metalist?.length; i++) {
        if (metalist[i].meta_key == "web_deeplink") {
          let deeplink = metalist[i].meta_value_english;
          setShowModal(true);
          setDeeplinktext(deeplink);
          return false;
        }
        if (metalist[i].meta_key == "web_notallowed") {
          //need to show popup for only app feature
          // console.log("exclusive feature for app");
          setShowModal(true);
          return false;
        }
        else if (metalist[i].meta_key == "web_redirection") {
          let _url = metalist[i].meta_value_english;
          if (_url.indexOf("http") >= 0) {
            window.open(_url, '_blank');
          }
          else {
            navigate("/" + _url);
            return false;
          }
          //return false;
        }
      }
    } else {
      // console.log("metalist count is zero");
    }
  }

  // console.log(list);
  return (
    <div className="radius_section" style={{borderRadius: '0'}}>
      <ul class="link_style_menu p-0">
        {/* <li key={item?.position}>
          <Link
            to={`/${item?.redirecturl}`}
            class="link_style_item flex_grp_align_center"
          >
            <div class="flex_grp_align_center flex1">
              <span>{item?.displaytext}</span>
            </div>
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/right_arrow_dark.svg"
              }
              alt=""
              title=""
              class="right_arrow"
              data-bs-toggle="modal"
              data-bs-target=".popup3"
            />
          </Link>
        </li> */}
        {list.map((item) => {
          return item?.metadata?.map((meta, metaindex) => {
            // { console.log(meta, "item") }
            // console.log(meta, "meta")
            if (
              meta.meta_key == "web_show" &&
              meta.meta_value_english == "true"
            ) {
              // console.log("returning li element", "li element")
              return (
                <li key={metaindex}>
                  <a onClick={() => { menuClick(item?.metadata) }}
                    //to={`/${item?.redirecturl}`}
                    class="link_style_item flex_grp_align_center"
                  >
                    <div class="flex_grp_align_center flex1">
                      <span>{item?.displaytext}</span>
                    </div>
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/right_arrow_dark.svg"
                      }
                      alt=""
                      title=""
                      class="right_arrow"
                      data-bs-toggle="modal"
                      data-bs-target=".popup3"
                    />
                  </a>
                </li>
              );
            }
          });
        })}
      </ul>
      <ExclusiveModal show={showModal} 
      toggleModal={toggleModal} deeplinktext={deeplinktext}/>
    </div>
  );
};

export default MoreAccountsList;
